import { resolveApiOrigin } from './apiOrigin';
export const API = { BASE_URL: resolveApiOrigin({
  nodeEnv: process.env.NODE_ENV,
  deploymentEnv: process.env.REACT_APP_DEPLOYMENT_ENV,
  apiOrigin: process.env.REACT_APP_API_ORIGIN
}) };
